module.exports = __webpack_public_path__ + "img/Gestor3.1f7caa95.png";